import React from 'react'

function SvgSchool(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" {...props}>
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M8.001 0c.08 0 .16.015.237.045l.081.044.097.054 3.334 2.666.025.031.081.097.074.109.034.11.028.139.008.035v2.667h3.333c.367 0 .667.3.667.666v8.667c0 .367-.3.667-.667.667H.666A.669.669 0 010 15.33V6.663c0-.366.3-.666.666-.666H4V3.33l.006-.034.03-.143.033-.106.075-.111.08-.096.026-.03L7.583.142l.1-.056.077-.042A.667.667 0 018.001 0zM8 1.517L5.333 3.65v3.013c0 .367-.3.667-.667.667H1.333v7.333H6v-2a2 2 0 014 0v2h4.666V7.33h-3.333a.669.669 0 01-.667-.667V3.651L8 1.517zm0 10.48a.667.667 0 00-.667.666v2h1.333v-2A.667.667 0 008 11.997zM4 8.663v1.334H2.667V8.663H4zm2.667 0v1.334H5.333V8.663h1.334zm4 0v1.334H9.333V8.663h1.334zm2.666 0v1.334H12V8.663h1.333zM8 3.33a1.334 1.334 0 11-.001 2.668 1.334 1.334 0 010-2.668z"
      />
    </svg>
  )
}

export default SvgSchool
